/**
 * @fileoverview Newsletter.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

function Newsletter() {
    const { t } = useTranslation();
    const [subscribeData, setSubscribeData] = useState({ name: '', email: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSubscribeData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert(`Thank you for subscribing, ${subscribeData.name}!`);
        setSubscribeData({ name: '', email: '' });
    };

  return (
    <div className='w-[90%] md:w-[85%] max-w-6xl mx-auto bg-KITH-primary-dark rounded-[2.5rem] p-8 md:p-14 mb-10 md:mb-16 relative z-10 overflow-hidden shadow-2xl flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12 group'>
        <div className='absolute top-0 right-0 w-1/2 h-full bg-white/5 skew-x-[-20deg] translate-x-20 transition-transform duration-1000 group-hover:translate-x-10'></div>
        
        <div className='flex flex-col gap-3 text-left z-10 max-w-lg'>
            <h3 className='text-2xl md:text-3xl font-bold text-white'>{t('newsletter.title')}</h3>
            <p className='text-white/80 text-sm md:text-base'>
                {t('newsletter.desc')}
            </p>
        </div>

        <form onSubmit={handleSubmit} className='flex flex-col sm:flex-row gap-3 w-full md:w-auto z-10'>
            <input 
                type="text" name="name" placeholder={t('newsletter.name_placeholder')}
                value={subscribeData.name} onChange={handleChange}
                className='p-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl text-white placeholder:text-white/60 outline-none focus:bg-white/20 transition-all text-sm md:text-base min-w-[150px]' 
                required 
            />
            <input 
                type="email" name="email" placeholder={t('newsletter.email_placeholder')}
                value={subscribeData.email} onChange={handleChange}
                className='p-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl text-white placeholder:text-white/60 outline-none focus:bg-white/20 transition-all text-sm md:text-base min-w-[200px]' 
                required 
            />
            <button className='py-4 px-8 bg-white text-KITH-primary font-bold rounded-xl hover:bg-gray-100 transition-all shadow-md active:scale-95 shrink-0 text-sm md:text-base'>
                {t('newsletter.button')}
            </button>
        </form>
    </div>
  )
}

export default Newsletter
